import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LOCALES } from '@whitbread-eos/api';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuTrigger } from '@whitbread-eos/atoms/ui';
import Image from 'next/image';
import Link from 'next/link';
const LanguageMenu = ({ languages, language = 'en', enIcon, deIcon })=>{
    const country = language === 'en' ? 'gb' : 'de';
    const selectedLanguage = languages === null || languages === void 0 ? void 0 : languages.find((lang)=>{
        var _lang_code;
        return (lang === null || lang === void 0 ? void 0 : (_lang_code = lang.code) === null || _lang_code === void 0 ? void 0 : _lang_code.toLowerCase()) === country;
    });
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "ghost",
                    size: "icon",
                    className: buttonStyle,
                    "data-testid": "Language-Switcher-Button",
                    children: /*#__PURE__*/ _jsx(Image, {
                        className: iconStyle,
                        src: language === 'en' ? enIcon : deIcon,
                        alt: language === 'en' ? 'English' : 'Deutsch',
                        width: 24,
                        height: 24
                    })
                })
            }),
            /*#__PURE__*/ _jsx(DropdownMenuContent, {
                className: dropdownStyle,
                align: "end",
                avoidCollisions: false,
                "data-testid": "Language-Switcher-Dropdown",
                children: languages === null || languages === void 0 ? void 0 : languages.map((language)=>{
                    var _language_language;
                    return /*#__PURE__*/ _jsx(Link, {
                        href: `/${language.code === 'de' ? LOCALES.DE : LOCALES.EN}/homepage`,
                        children: /*#__PURE__*/ _jsxs(DropdownMenuCheckboxItem, {
                            checked: (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) === language.code,
                            className: itemStyle,
                            indicatorPosition: "right",
                            "data-testid": `${language.language}-Button`,
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    className: dropdownIconStyle,
                                    loading: "eager",
                                    src: language.code === 'gb' ? enIcon : deIcon,
                                    alt: (_language_language = language === null || language === void 0 ? void 0 : language.language) !== null && _language_language !== void 0 ? _language_language : '',
                                    width: 24,
                                    height: 24
                                }),
                                language.language
                            ]
                        })
                    }, language.code);
                })
            })
        ]
    });
};
export default LanguageMenu;
const buttonStyle = 'focus-visible:ring-0 focus-visible:ring-offset-0 rounded-full w-11 h-11 bg-lightGrey5 rounded-full hover:bg-initial shrink-0';
const dropdownStyle = 'w-[12.5rem] shadow p-0 box-border border-lightGrey3 rounded';
const itemStyle = 'text-base px-4 py-2.5 hover:bg-lightGrey5 gap-4';
const iconStyle = 'text-transparent';
const dropdownIconStyle = 'text-transparent';
